export default __webpack_public_path__ + "static/media/Novaa_Futurist_Still_2.942cccbb.jpg";